document.addEventListener('DOMContentLoaded', () => {
    const textarea = document.querySelectorAll('.base-textarea')
    const body = document.querySelector('body')

    textarea.forEach((item) => {
        item.addEventListener('input', () => {
            item.style.height = 'auto'
            item.style.height = item.scrollHeight + 'px'
        })
    })
    const blackBackground = document.querySelector('.black-background')
    const header = document.querySelector('header')

    const dropdowns = [
        {
            link: document.querySelector('#customers'),
            menu: document.querySelector('.header__menu-customers'),
        },
        {
            link: document.querySelector('#partners'),
            menu: document.querySelector('.header__menu-partners'),
        },
    ]

    let activeDropdown = null
    let hideTimeout = null

    function hideAll() {
        dropdowns.forEach(({ menu }) => {
            menu.style.display = 'none'
        })

        // Закрываем фон только если НЕ открыт поиск
        if (searchDropdown.style.display !== 'flex') {
            blackBackground.style.display = 'none'
        }

        activeDropdown = null
    }

    function show(menu) {
        hideAll()
        menu.style.display = 'flex'
        blackBackground.style.display = 'block'
        activeDropdown = menu
    }

    function attachHover({ link, menu }) {
        if (!link || !menu) return

        // Вход на ссылку
        link.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout)
            show(menu)
        })

        // Выход с ссылки
        link.addEventListener('mouseleave', (e) => {
            if (!menu.contains(e.relatedTarget)) {
                hideTimeout = setTimeout(() => {
                    if (activeDropdown === menu) hideAll()
                }, 200)
            }
        })

        // Вход в меню
        menu.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout)
            show(menu)
        })

        // Выход из меню
        menu.addEventListener('mouseleave', (e) => {
            if (!link.contains(e.relatedTarget)) {
                hideTimeout = setTimeout(() => {
                    if (activeDropdown === menu) hideAll()
                }, 200)
            }
        })
    }

    // навешиваем логику на каждый dropdown
    dropdowns.forEach(attachHover)

    // клик вне области
    document.addEventListener('click', (e) => {
        if (!dropdowns.some(({ link, menu }) => link.contains(e.target) || menu.contains(e.target))) {
            hideAll()
        }
    })

    const searchDropdown = document.querySelector('.header__search')
    const searchSvg = header.querySelector('.icon-search')
    const closeSearch = document.querySelector('#close-search')

    searchSvg.addEventListener('click', () => {
        searchDropdown.style.display = 'flex'
        blackBackground.style.display = 'block'
    })

    closeSearch.addEventListener('click', (e) => {
        e.preventDefault()
        searchDropdown.style.display = 'none'
        blackBackground.style.display = 'none'
    })

    const burger = header.querySelector('.header__burger')
    const sidebar = document.querySelector('.sidebar')

    burger.addEventListener('click', () => {
        burger.classList.toggle('header__burger--active')
        sidebar.classList.toggle('sidebar--active')
        body.classList.toggle('body--scroll-disabled')
    })

    const headersOfLists = document.querySelectorAll('.sidebar__list-header-wrapper')

    headersOfLists.forEach((header) => {
        const listContent = header.nextElementSibling
        const svgWrapper = header.querySelector('.sidebar__cross-svg-wrapper')
        header.addEventListener('click', () => {
            listContent.classList.toggle('sidebar__list-content-wrapper--active')
            svgWrapper.classList.toggle('sidebar__cross-svg-wrapper--active')
        })
    })

    const footer = document.querySelector('footer')
    const footerAccordionItems = footer.querySelectorAll('.footer__list-wrapper')

    console.log(footerAccordionItems)

    footerAccordionItems.forEach((item) => {
        const header = item.querySelector('.footer__list-title-wrapper')
        const listContent = item.querySelector('.footer__list-container')
        const svgWrapper = header.querySelector('.catalog-sidebar__cross-svg-wrapper')
        header.addEventListener('click', () => {
            listContent.classList.toggle('footer__list-container--active')
            svgWrapper.classList.toggle('catalog-sidebar__cross-svg-wrapper--active')
        })
    })

    const eyesSvg = document.querySelectorAll('.icon-eye.base-input__icon')

    eyesSvg.forEach((eye) => {
        eye.addEventListener('click', () => {
            const useElement = eye.querySelector('use')
            const input = eye.closest('.base-input__container').querySelector('.base-input')
            if (input.getAttribute('type') === 'password') {
                input.setAttribute('type', 'text')
                useElement.setAttribute('href', '/local/html/images/sprite.svg#eye-open')
            } else {
                input.setAttribute('type', 'password')
                useElement.setAttribute('href', '/local/html/images/sprite.svg#eye-closed')
            }
        })
    })

    const favoriteSvg = document.querySelectorAll('.product-card__favorite-svg')

    favoriteSvg.forEach((svg) => {
        svg.addEventListener('click', () => {
            const innerSvg = svg.querySelector('use')
            if (innerSvg.getAttribute('href') === '/local/html/images/sprite.svg#heart-fill') {
                innerSvg.setAttribute('href', '/local/html/images/sprite.svg#heart')
            } else {
                innerSvg.setAttribute('href', '/local/html/images/sprite.svg#heart-fill')
            }
        })
    })
})
